import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { ProtectedRoute } from "./components/ProtectedRoute";

import HomePage from "./pages/Home";
import CheckoutPage from "./pages/Checkout";
import PaymentStatusPage from "./pages/PaymentStatus";
import ContactPage from "./pages/Contact";
import MyProjectPage from "./pages/MyProject";
import ArtworksPage from "./pages/Artworks";
import AdminLoginPage from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { TermsPage, ReturnsPage, PrivacyPage } from "./pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Header />
            <CartDrawer />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/artworks" element={<ArtworksPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/payment-status" element={<PaymentStatusPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/project" element={<MyProjectPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/returns" element={<ReturnsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Footer />
            <Toaster
              position="top-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#050505",
                  border: "1px solid rgba(255,255,255,0.08)",
                  color: "white",
                },
              }}
            />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
